<section class="table-page table-page--compact mis-proyectos-page mis-proyectos-detail-page hucu-sprint-page">
  <div class="table-page__hero">
    <div class="table-page__copy">
      <h1>Sprints del Proyecto</h1>
      <p>{{ getProjectName() }}</p>
    </div>

    <div class="table-page__toolbar-actions">
      <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
        (click)="regresarLista()">
        <span class="material-icons">arrow_back</span>
        <span>Regresar</span>
      </button>
      <button mat-raised-button type="button" class="btn table-page__primary-btn" (click)="agregaModificaSprint(null)">
        <span class="material-icons">add</span>
        <span>Agregar Sprint</span>
      </button>
    </div>
  </div>

  <section class="table-page__card">
    <div class="table-page__toolbar">
      <div class="table-page__meta">
        <span>Proyecto: {{ getProjectName() }}</span>
        <span>ID: {{ proyecto?.id || "-" }}</span>
      </div>
    </div>

    <div class="table-page__table-wrap">
      <table class="table-page__table" *ngIf="listSprints.length > 0; else sprintEmptyState">
        <thead>
          <tr>
            <th>Sprint</th>
            <th>Fechas</th>
            <th>Estatus</th>
            <th>Etapa</th>
            <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of listSprints">
            <td>
              <div class="table-page__cell-stack">
                <strong class="table-page__name">{{ row.nombre || "Sin nombre" }}</strong>
                <span class="table-page__subtext">Sprint #{{ row.id }}</span>
              </div>
            </td>
            <td>
              <span class="table-page__text">{{ getDateRangeLabel(row) }}</span>
            </td>
            <td>
              <span class="table-page__status-badge" [ngClass]="getStatusClass(row)">
                {{ getStatusLabel(row) }}
              </span>
            </td>
            <td>
              <span class="table-page__text">{{ getEtapaLabel(row) }}</span>
            </td>
            <td class="table-page__actions table-page__actions--multi">
              <div class="table-page__action-group">
                <button type="button" class="table-page__action-btn" matTooltip="Modificar sprint"
                  (click)="agregaModificaSprint(row)">
                  <i class="material-icons">edit</i>
                </button>
                <button type="button" class="table-page__action-btn" matTooltip="Agregar historias de usuario"
                  (click)="agregarHUSprint(row)">
                  <i class="material-icons">playlist_add</i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #sprintEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else sprintLoadingState">
          <i class="material-icons">view_kanban</i>
          <strong>No hay sprints para mostrar</strong>
          <span>Agregue un sprint para comenzar a planear historias de usuario.</span>
        </div>
      </ng-template>

      <ng-template #sprintLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando sprints...</strong>
        </div>
      </ng-template>
    </div>

    <div class="table-page__footer" *ngIf="showPagination">
      <div class="table-page__meta">
        <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} sprints</span>
        <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

        <label class="table-page__page-size">
          <span>Ver:</span>
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
      </div>

      <div class="table-page__pager" *ngIf="totalPages > 0">
        <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
          Inicio
        </button>
        <button type="button" class="table-page__pager-link" (click)="previousPage()"
          [disabled]="currentPage === 1">
          Anterior
        </button>

        <ng-container *ngFor="let item of getPaginationItems()">
          <button *ngIf="isPageNumber(item); else sprintPagerEllipsis" type="button" class="table-page__pager-page"
            [class.is-current]="item === currentPage" (click)="onPageChange(item)">
            {{ item }}
          </button>

          <ng-template #sprintPagerEllipsis>
            <span class="table-page__pager-ellipsis">...</span>
          </ng-template>
        </ng-container>

        <button type="button" class="table-page__pager-link" (click)="nextPage()"
          [disabled]="currentPage === totalPages">
          Siguiente
        </button>
        <button type="button" class="table-page__pager-link" (click)="lastPage()"
          [disabled]="currentPage === totalPages">
          Último
        </button>
      </div>
    </div>
  </section>
</section>
